export default __webpack_public_path__ + "static/media/rnr-sports-table-23-cn.373aeaa6.webp";